export const MERCHANT_ID = /^(alis|monolith)[-*][a-z0-9]+$/i

export const normalizeMerchantId = (merchantId: string): string => {
  const trimmed = merchantId.trim().toLowerCase()
  if (trimmed.includes('*')) return trimmed

  const dashIndex = trimmed.indexOf('-')
  return dashIndex < 0 ? trimmed : `${trimmed.slice(0, dashIndex)}*${trimmed.slice(dashIndex + 1)}`
}
